import {useState} from "react";
import FormContent from './FormContent';
import Button from "./Button";
import dayjs from "dayjs";
import {db} from "../firebase";
import {update, ref} from "firebase/database";

function Modal({note, setShowModal}) {
  const [activeNote, setNote] = useState(note);
  const [valid, setValid] = useState(true);

  function updateNote() {
    const date = new Date();

    update(ref(db, `/${activeNote.id}`), {
      title: activeNote.title,
      text: activeNote.text,
      updateDate: dayjs(date).format('MMMM DD, HH:mm:ss A'),
    });

    setShowModal(false);
  }

  function onClickHandler() {
    activeNote.text.length > 0 ? updateNote() : setValid(false);
  };

  return (
    <div className="modal-container" onClick={() => {setShowModal(false)}}>
      <div className={"modal-wrapper modal-wrapper" + note.status} onClick={e => {e.stopPropagation()}}>
        <svg className="modal-close" onClick={() => {setShowModal(false)}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
        </svg>
        <FormContent
          note={activeNote}
          setNote={setNote}
          valid={valid}
          setValid={setValid}
        />
      <Button onClickHandler={onClickHandler} text="Update note"/>
      </div>
    </div>
  );
}

export default Modal;